// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import React from 'react';

export const CyberKoalaCallsRoundedIcon = ({
  width,
  height,
  className,
  style
}: {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}) => (
  <img
    src="/icons/cyberkoala-calls-26-flat-rounded.svg"
    alt="CyberKoala Calls"
    width={width || 24}
    height={height || 24}
    className={className}
    style={style}
  />
);
